export default "__VITE_ASSET__BtF8fMp2__"